import { View, XStack, useWindowDimensions, StackedBarChart, DonutChart, SimpleText, Progress, XPProgressBar } from '@my/ui'
import { color, FormatUtils, TZABrandGuidelines, useResizeObserver } from '@my/util'
import { useMemo } from 'react'

interface GoalBarChartProp {
  goalName: string // Name of the goal
  goalProgress: number // Progress of the goal as a percentage (0-100)
}
interface props {
  overallGoalCompletionPercentage?: number
  totalTargetAmount?: number
  goals?: GoalBarChartProp[]
}



export const FinancialGoalChart = ({
  overallGoalCompletionPercentage = 80,
  goals = [],
  totalTargetAmount = 0
}: props) => {
  return <XPProgressBar 
    value={overallGoalCompletionPercentage}
    primaryColor={TZABrandGuidelines.colorsMap.primaryGreen}
    secondaryColor={TZABrandGuidelines.colorsMap.secondaryMustard}
    borderRadius={14}

  >
    <XStack style={{
      marginLeft: 'auto',
      alignItems: 'center',
      height: '100%',
      position: 'relative',
    }}>
      <SimpleText style={{
        color: 'white', marginLeft: 'auto', paddingRight: 5, 
        textShadow: '0px 0px 3px rgba(0,0,0,.6)', 
        fontWeight: 500,
        position: 'relative',
        //height: '100%'
      }}>{
        overallGoalCompletionPercentage.toFixed(0) + '%'
      }</SimpleText>
    </XStack>
  </XPProgressBar>
  const [containerDimensions, containerDimensionProps] = useResizeObserver();
  const overallTargetAmount = FormatUtils.currency.cashFormat(totalTargetAmount, {decimalPlaces: 0});
  const percentForProgressbar = Math.round(Math.min(100,10 + (90*(overallGoalCompletionPercentage/100))))
  const backgroundGradient = `linear-gradient(to right, ${TZABrandGuidelines.colorsMap.secondaryMustard} ${100-overallGoalCompletionPercentage}%, ${TZABrandGuidelines.colorsMap.primaryGreen})`
  return <XStack style={{
    justifyContent: "flex-start",
    overflow: 'hidden',
    backgroundColor: 'rgb(240,240,240)',
    borderRadius: '14px'
  }}>
    <XStack style={{
      height: '100%',
      width: percentForProgressbar+'%',
      background: backgroundGradient
    }}>
      <SimpleText 
        style={{color: 'white', marginLeft: 'auto', paddingRight: 5, textShadow: '0px 0px 3px rgba(0,0,0,.6)', fontWeight:500}}
      >{
        overallGoalCompletionPercentage.toFixed(0) + '%'
      }</SimpleText>
    </XStack>
  </XStack>
}

export const FinancialGoalChartOld2 = ({
  overallGoalCompletionPercentage = 80,
  goals = [],
  totalTargetAmount = 0
}: props) => {
  const [containerDimensions, containerDimensionProps] = useResizeObserver();
  const overallTargetAmount = FormatUtils.currency.cashFormat(totalTargetAmount, {decimalPlaces: 0});
  const percentForProgressbar = 10 + (90*(overallGoalCompletionPercentage/100))
  return <View width="100%" /* {...containerDimensionProps} */>
    <Progress size={'$4'} value={percentForProgressbar} style={{width: containerDimensions.width, height: 26, background: 'rgb(248,248,248)'}}>
      <Progress.Indicator style={{justifyContent: 'center'}} transition="bouncy" background={`linear-gradient(to right, ${TZABrandGuidelines.colorsMap.secondaryMustard} ${100-overallGoalCompletionPercentage}%, ${TZABrandGuidelines.colorsMap.primaryGreen})`}>
        
        <SimpleText 
          style={{color: 'white', marginLeft: 'auto', paddingRight: 5, textShadow: '0px 0px 3px rgba(0,0,0,.6)', fontWeight:500}}
        >{
          overallGoalCompletionPercentage.toFixed(0) + '%'
        }</SimpleText>
        </Progress.Indicator>
    </Progress>

  </View>
}

const FinancialGoalChartOld = ({
  overallGoalCompletionPercentage = 80,
  goals = [],
  totalTargetAmount = 0,
}: props) => {
  const isLargeScreen = useWindowDimensions().width > 600

  const remainingPercentage = 100 - overallGoalCompletionPercentage
  const OverallGoalCompletionData = useMemo(() => {
    return [
      {
        x: `${overallGoalCompletionPercentage}%`,
        y: overallGoalCompletionPercentage,
        label: `${overallGoalCompletionPercentage.toFixed(2)}%`,
      },
      {
        x: `${remainingPercentage}%`,
        y: remainingPercentage,
        label: '',
      },
    ]
  }, [overallGoalCompletionPercentage, remainingPercentage])
  const progressData = goals?.map((item) => ({
    x: item.goalName,
    y: item.goalProgress,
  }))

  return (
    <YStack gap={25} flexDirection={isLargeScreen ? 'row' : 'column'} flexWrap="wrap" flex={1}>
      <YStack gap={10}>
        <YStack gap={10}>
          <SimpleText fontSize={14} lineHeight={29} fontWeight={'800'} color={'#555555'}>
            Overall Goal Completion
          </SimpleText>
          <SimpleText fontSize={24} lineHeight={32} fontWeight={'800'} color={'#85C19D'}>
            {overallGoalCompletionPercentage.toFixed(2)}%
          </SimpleText>
        </YStack>
        <DonutChart
          data={OverallGoalCompletionData}
          legendData={[
            { name: 'Completed', fill: '#4ECDC4' },
            { name: 'Pending', fill: '#FF6B6B' },
          ]}
        />
      </YStack>
      <YStack gap={10}>
        <YStack gap={10}>
          <SimpleText fontSize={14} lineHeight={29} fontWeight={'800'} color={'#555555'}>
            Goal Progress Breakdown
          </SimpleText>
          <SimpleText fontSize={24} lineHeight={32} fontWeight={'800'} color={'#85C19D'}>
            {FormatUtils.currency.cashFormat(totalTargetAmount, {decimalPlaces: 0})}
          </SimpleText>
        </YStack>
        <StackedBarChart
          horizontal
          data={[progressData]}
          stackColorScale={[color.cyan]}
          legendData={[{ name: 'Current Progress', fill: color.cyan }]}
          type="percentage"
        />
      </YStack>
    </YStack>
  )
}
